import React from "react";

import cx from "classnames";
import { t, Trans } from "@lingui/macro";

import "./Tab.css";

export default function Tab (props) {
  const { options, option, setOption, onChange, type = "block", className, optionLabels, icons } = props;

  const onClick = (opt) => {
    if (setOption) {
      setOption(opt);
    }
    if (onChange) {
      onChange(opt);
    }
  };

  return (
    <div className={cx("Tab", type, className)}>
      {options.map((opt) => {
        const label = optionLabels && optionLabels[opt] ? optionLabels[opt] : opt;

        return (
          <div className={cx("Tab-option", "muted", { active: opt === option })} onClick={() => onClick(opt)} key={opt}>
            {!(opt === option) && icons && icons[opt] && <img className="Tab-option-icon" src={icons[opt]} alt={option} />}
            {opt === option && icons && icons[opt + '_active'] && <img className="Tab-option-icon" src={icons[opt + '_active']} alt={option} />}
            <span className="text"><Trans id={label}></Trans></span>
            {/* <span className="text">{optionLabels ? label : <Trans id={label}></Trans>}</span> */}
          </div>
        );
      })}
    </div>
  );
}
